/* ============================================================================
   coverage-co.js — iShop Colombia
   Resolución de ubicación y zona de cobertura.
   Depende de: coverage-co-data.js (CO_ZONES, CO_SLA, CO_BOGOTA_LINE,
               CO_DEPT_RING_KM, CO_PICKUP_CITIES) y de window.ISHOP_CO_STORES
               + window.ANNOUNCEMENT_CONFIG_CO (inyectados por la sección).
   Expone: window.COCoverage = { resolve(cb), isBogotaNorte(lat,lng),
            setStore(locationId), clear() }
   ----------------------------------------------------------------------------
   Prioridad de fuentes de ubicación (igual patrón que PE):
     1. GPS vigente (TTL configurable, default 6 h) — localStorage
     2. Tienda elegida por el usuario (localStorage, sin vencimiento)
     3. Sin ubicación -> zone null (la barra deja el mensaje por defecto)
   El GPS NO se solicita proactivamente: solo se lee si ya fue concedido
   (permissions API) o si otra parte del sitio lo pidió. Menor fricción.
   ============================================================================ */
(function (w) {
  'use strict';

  function cfg() { return w.ANNOUNCEMENT_CONFIG_CO || {}; }

  /* Claves de localStorage. lsPrefix es configurable para que entornos de
     QA (harness) usen claves propias y NUNCA contaminen las del sitio. */
  function LS_GPS()   { return (cfg().lsPrefix || 'ishop_co_') + 'gps'; }    /* {lat,lng,ts} */
  function LS_STORE() { return (cfg().lsPrefix || 'ishop_co_') + 'store'; }  /* locationId */

  /* ---------- geometría ---------- */
  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  /* Norte de Bogotá = lado nororiental (Chapinero/Usaquén/Suba/Chicó +
     eje Gran Estación) de la línea El Dorado->Monserrate corrida 1 km SW. */
  function isBogotaNorte(lat, lng) {
    var L = w.CO_BOGOTA_LINE, A = L.a, B = L.b;
    var cross = (B.lng - A.lng) * (lat - A.lat) - (B.lat - A.lat) * (lng - A.lng);
    return cross > 0;
  }

  /* ---------- resolución de zona desde coordenadas ---------- */
  function zoneFromCoords(lat, lng) {
    var zones = w.CO_ZONES || [];
    var best = null, bestD = Infinity, i, z, d;
    for (i = 0; i < zones.length; i++) {
      z = zones[i];
      d = haversineKm(lat, lng, z.lat, z.lng);
      if (d < bestD) { bestD = d; best = z; }
    }
    if (!best) return { key: 'otros', dist: null };
    if (bestD <= best.radiusKm) return { key: best.key, dist: bestD };
    /* segundo anillo: "resto del departamento" de la ciudad más cercana */
    if (bestD <= (w.CO_DEPT_RING_KM || 80) && best.deptKey) {
      return { key: best.deptKey, dist: bestD };
    }
    return { key: 'otros', dist: bestD };
  }

  /* ---------- fuentes de ubicación ---------- */
  function readGps() {
    try {
      var raw = w.localStorage.getItem(LS_GPS());
      if (!raw) return null;
      var g = JSON.parse(raw);
      var ttl = (cfg().gpsTtlSegundos || 21600) * 1000;
      if (!g || !g.ts || (Date.now() - g.ts) > ttl) return null;
      return g;
    } catch (e) { return null; }
  }

  function saveGps(lat, lng) {
    try { w.localStorage.setItem(LS_GPS(), JSON.stringify({ lat: lat, lng: lng, ts: Date.now() })); } catch (e) {}
  }

  function readStore() {
    try {
      var id = w.localStorage.getItem(LS_STORE());
      if (id && w.ISHOP_CO_STORES && w.ISHOP_CO_STORES[id]) {
        var s = w.ISHOP_CO_STORES[id];
        return { lat: s.lat, lng: s.lng, city: s.city, storeId: id };
      }
    } catch (e) {}
    return null;
  }

  /* Refresca GPS silenciosamente SOLO si el permiso ya está concedido. */
  function refreshGpsIfGranted() {
    if (!('permissions' in navigator) || !('geolocation' in navigator)) return;
    navigator.permissions.query({ name: 'geolocation' }).then(function (st) {
      if (st.state !== 'granted') return;
      navigator.geolocation.getCurrentPosition(function (pos) {
        saveGps(pos.coords.latitude, pos.coords.longitude);
        emit();
      }, function () {}, { maximumAge: 300000, timeout: 8000, enableHighAccuracy: false });
    }).catch(function () {});
  }

  /* ---------- integración con my-store-locator.js (patrón PE) ----------
     El store locator del theme es el DUEÑO del prompt de geolocalización:
     al aceptar escribe la cookie 'location_position' (JSON {coords:{...}}),
     y al elegir tienda escribe localStorage 'preferredStoreId' (GID de
     Storefront). Aquí solo LEEMOS ese estado — nunca lo escribimos — para
     que la barra reaccione a la misma ubicación que el resto del sitio,
     incluso en Safari/iOS donde no existe la Permissions API. */
  function getCookie(name) {
    try {
      var nameEQ = name + '=';
      var ca = (w.document && w.document.cookie) ? w.document.cookie.split(';') : [];
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
      }
    } catch (e) {}
    return null;
  }
  /* Cookie del locator; puede venir en JSON plano o percent-encoded
     (mismo fix de tolerancia que en PE). */
  function readLocatorPosition() {
    var raw = getCookie('location_position');
    if (!raw) return null;
    var pos = null;
    try { pos = JSON.parse(raw); }
    catch (e) { try { pos = JSON.parse(decodeURIComponent(raw)); } catch (e2) { pos = null; } }
    var lat = pos && pos.coords && pos.coords.latitude;
    var lng = pos && pos.coords && pos.coords.longitude;
    if (typeof lat === 'number' && typeof lng === 'number') return { lat: lat, lng: lng };
    return null;
  }
  /* preferredStoreId del locator: GID 'gid://shopify/Location/NNN' o el
     número pelado. Se mapea contra ISHOP_CO_STORES (claves numéricas). */
  function readPreferredStore() {
    try {
      var id = w.localStorage.getItem('preferredStoreId');
      if (!id) return null;
      var num = String(id).split('/').pop();
      var s = (w.ISHOP_CO_STORES || {})[num] || (w.ISHOP_CO_STORES || {})[id];
      if (s) return { lat: s.lat, lng: s.lng, city: s.city, storeId: num };
    } catch (e) {}
    return null;
  }

  /* ---------- API ---------- */
  var listeners = [];

  function currentResolution() {
    /* Prioridad: 1) GPS propio fresco (TTL)  2) cookie del locator
       3) tienda elegida vía nuestra API  4) preferredStoreId del locator */
    var gps = readGps();
    if (gps) return resolutionFromCoords(gps.lat, gps.lng, 'gps');

    var loc = readLocatorPosition();
    if (loc) return resolutionFromCoords(loc.lat, loc.lng, 'locator');

    var st = readStore() || readPreferredStore();
    if (st) {
      var zk = st.city;
      var sla = (w.CO_SLA || {})[zk] || w.CO_SLA.otros;
      return {
        source: 'store', lat: st.lat, lng: st.lng, zoneKey: zk, sla: sla,
        bogotaNorte: zk === 'bogota' ? isBogotaNorte(st.lat, st.lng) : null,
        pickup: (w.CO_PICKUP_CITIES || []).indexOf(zk) !== -1
      };
    }
    return null;
  }

  function resolutionFromCoords(lat, lng, source) {
    var z = zoneFromCoords(lat, lng);
    return {
      source: source, lat: lat, lng: lng, zoneKey: z.key,
      sla: (w.CO_SLA || {})[z.key] || w.CO_SLA.otros,
      bogotaNorte: z.key === 'bogota' ? isBogotaNorte(lat, lng) : null,
      pickup: (w.CO_PICKUP_CITIES || []).indexOf(z.key) !== -1
    };
  }

  function emit() {
    var res = currentResolution();
    for (var i = 0; i < listeners.length; i++) { try { listeners[i](res); } catch (e) {} }
  }

  w.COCoverage = {
    isBogotaNorte: isBogotaNorte,
    zoneFromCoords: zoneFromCoords,
    /* Resolución ACTUAL, siempre fresca (lee localStorage al momento).
       Usada por el heartbeat de announcement-delivery-co.js. */
    current: currentResolution,
    /* Relee el GPS en silencio si el permiso ya fue concedido. El heartbeat
       lo invoca periódicamente para captar autorizaciones a mitad de sesión. */
    refreshIfGranted: refreshGpsIfGranted,
    /* cb recibe null (sin ubicación) o el objeto de currentResolution() */
    resolve: function (cb) {
      if (typeof cb === 'function') listeners.push(cb);
      emit();
      refreshGpsIfGranted();
    },
    setStore: function (locationId) {
      try { w.localStorage.setItem(LS_STORE(), String(locationId)); } catch (e) {}
      emit();
    },
    setGps: function (lat, lng) { saveGps(lat, lng); emit(); },
    clear: function () {
      try { w.localStorage.removeItem(LS_GPS()); w.localStorage.removeItem(LS_STORE()); } catch (e) {}
      emit();
    }
  };
})(window);
